module.exports = __webpack_public_path__ + "media/images/pages/primary-toolkit/allen-36a7a75d60efe9c2e7d5f1ffa455b5a7.png";